// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1zIz4","header":"ClearentDisclaimer_header__3tz28","inner":"ClearentDisclaimer_inner__2ldkc"};